import React from 'react';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { Title } from 'react-admin';
import IngredientsImage from '../../extensions/neo/insights/Invoices-Ingredients-Insights.png';

/**
 * Ingredients Insights Placeholder Page
 * 
 * This component will display insights about ingredients,
 * including usage patterns, costs, and recommendations.
 */
export const IngredientsInsights = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Title title="Ingredients Insights" />
      
      <Card>
        <CardHeader 
          title="Ingredients Insights" 
          subheader="Coming Soon - Ingredient Analytics and Insights"
        />
        <CardContent>
          <Typography variant="body1" gutterBottom>
            This page will provide comprehensive insights about ingredients, including:
          </Typography>
          
          <Box sx={{ marginTop: 2, marginLeft: 2 }}>
            <Typography variant="body2" component="ul">
              <li>Ingredient usage trends and patterns</li>
              <li>Cost analysis per ingredient</li>
              <li>Supplier performance metrics</li>
              <li>Inventory levels and turnover rates</li>
              <li>Waste reduction opportunities</li>
              <li>Seasonal availability and pricing</li>
            </Typography>
          </Box>
          
          <Box 
            sx={{ 
              marginTop: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              padding: 2,
              borderRadius: 1,
              overflow: 'auto'
            }}
          >
            <img 
              src={IngredientsImage} 
              alt="Ingredients Insights Design Mockup" 
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }} 
            />
          </Box>
          
          <Typography 
            variant="caption" 
            display="block" 
            sx={{ marginTop: 2, textAlign: 'center', color: 'text.secondary' }}
          >
            Design mockup for the upcoming Ingredients Insights interface
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default IngredientsInsights;

